import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import { Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../Config/FbConfig";
import "swiper/css";
import "swiper/css/effect-fade";
import "./styles/Lander.css";

// Assuming Styles is a styled-components wrapper or similar
import { Styles } from "./styles/landerBlock.js";

const LanderBlock = () => {
  const [datas, setDatas] = useState([]);
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(firestore, "Home", "LandingPageSlider");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = Object.entries(docSnap.data()).map(([key, value]) => ({
            id: key,
            ...value,
          }));
          setDatas(data);
        } else {
          console.error("No document found!");
          setDatas([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setDatas([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(firestore, "Home", "ImportantNotification");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        let Data = [];
        Object.entries(docSnap.data()).forEach(([key, value]) => {
          Data.push(Object.assign({ Id: key }, value));
        });
        setData(Data);
        setLoading(false);
      } else {
        setData("NO_999");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const swiperSettings = {
    modules: [Autoplay, EffectFade],
    slidesPerView: 1,
    loop: true,
    speed: 2000,
    effect: "fade",
    fadeEffect: { crossFade: true }, // Smooth fade
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  };

  return (
    <Styles>
      {loading ? (
        <div>Loading...</div>
      ) : datas.length === 0 ? (
        <div>No data available</div>
      ) : (
        <>
          {/* Marquee */}
          <marquee
            className="example1"
            direction="left"
            scrollamount="5"
            behavior="scroll"
          >
            {Data?.map(
              (data) =>
                data.Header &&
                data.Header.trim() !== "" &&
                data.Content &&
                data.Content.trim() !== "" && (
                  <a
                    key={data.id}
                    target="_blank"
                    href={data.Content}
                    rel="noopener noreferrer"
                  >
                    {data.Header}&nbsp;&nbsp;
                  </a>
                )
            )}
          </marquee>

          <Swiper {...swiperSettings}>
            {datas?.map((data) => (
              <SwiperSlide key={data.id}>
                <section
                  className="bitHeader-area"
                  style={{
                    backgroundImage: `url(${
                      isMobile && data.ImageMobile
                        ? data.ImageMobile
                        : data.Image
                    })`,
                    width: "100%",
                    height: "50vh",
                    backgroundSize: "100% 100%", // stretch to fit both width and height
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <Container>
                    <Row>
                      <Col md={12} className={data.class}>
                        {data.Name && data.Name.trim() !== "" && (
                          <h4 className="title" style={{ color: "white" }}>
                            {data.Name}
                          </h4>
                        )}

                        {data.Description && data.Description.trim() !== "" && (
                          <h6 style={{ color: "white" }}>{data.Description}</h6>
                        )}

                        {data.ButtonName &&
                          data.ButtonName.trim() !== "" &&
                          data.ButtonLink &&
                          data.ButtonLink.trim() !== "" &&
                          (data.ButtonLink.startsWith("http") ? (
                            <a
                              href={data.ButtonLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <button>{data.ButtonName}</button>
                            </a>
                          ) : (
                            <Link to={process.env.PUBLIC_URL + data.ButtonLink}>
                              <button>{data.ButtonName}</button>
                            </Link>
                          ))}
                      </Col>
                    </Row>
                  </Container>
                </section>
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
    </Styles>
  );
};

export default LanderBlock;
